import { forwardRef } from "react";
import { Skeleton, TextField, TextFieldProps } from "@mui/material";

type LoadingTextFieldProps = {
  isLoading?: boolean;
} & TextFieldProps;

const LoadingTextField = forwardRef<HTMLInputElement, LoadingTextFieldProps>(
  (props, ref) => {
    const { isLoading, ...rest } = props;
    if (isLoading) {
      return (
        <Skeleton variant="rectangular" sx={{ borderRadius: 1 }} height={48} />
      );
    }
    return <TextField {...rest} inputRef={ref} />;
  }
);

export default LoadingTextField;
